<template>
  <div class="login-layout">
    <div class="login-container">
      <div class="left">
        <slot /> 
      </div>
      <div class="right">
        <img src="@/assets/login.svg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginLayout',
  components: {},
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style lang="less" scoped>
.login-layout {
  display: flex;
  justify-content: center;
  min-height: 100vh;
  background-image: url('../assets/loginbg.svg');
  min-width: 1366px;
  background-color: #F7FAFC;

  .login-container {
    flex: 1 1 0%;
    margin: 5rem;
    max-width: 1280px;
    display: flex;
    justify-content: center;
    box-shadow: 0 2px 12px #ddd;
    border: 1px solid #ebeef5;
    border-radius: 5px;
    background-color: #fff;

    .left{
      width: 42%;
      padding: 3rem;
      box-sizing: border-box;
    }
    .right{
      flex: 1 1 10%;
      background-color: #ebf4ff;
      padding: 4rem;
      display: flex;
      align-items: center;
      img {
        width: 100%;
      }
    }
  }
}
</style>
